var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdminPanelIcon = function SvgAdminPanelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3AACC8",
    d: "M29.053 14.5v11L19.526 31 10 25.5v-11L19.526 9zM12.766 24.981l5.844 3.374v-6.659zm7.676-4.329v7.703l5.844-3.374-2.903-1.631.897-1.597 2.94 1.652v-6.77zM12.73 15.04l2.959 1.753-.934 1.575-2.922-1.731v6.77l7.236-4.068 7.254-4.299-6.796-3.924z"
  })));
};
export { SvgAdminPanelIcon as ReactComponent };
export default __webpack_public_path__ + "0d3edd4507c6799691ab98bc6f95bd9a.svg";